module.exports = __webpack_public_path__ + "static/media/galway-10.1d46f0ca.jpg";